import axios from "axios";
import qs from "qs";
import {baseURL} from "./baseURL"
axios.defaults.timeout = 60000; //响应时间

axios.defaults.baseURL = baseURL //配置接口地址


//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  config => {
    //在发送请求之前做某件事
    // config.headers['accesstoken'] = 'c41ee46ef177f02a5c652ef57899610ce8952891';
    // config.headers['X-Openerp-Session-Id'] = '3a54d3a8ce177278c1f873bf83f32c1656763d63';
	
    if (config.method === "post") {
      config.data = qs.stringify(config.data);
	  var session_id = window.localStorage.getItem('session_id')
	  if(session_id){
		  config.data += `&session_id=${session_id}`;
	  } 
    }
	// debugger
    return config;
  },
  error => {
    console.log("错误的传参");
    return Promise.reject(error);
  }
);

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    //对响应数据做些事
    if (!res.data.success) {
      return Promise.resolve(res);
    }
    return res;
  },
  error => {
    console.log("网络异常");
    return Promise.reject(error);
  }
);

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
	
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(
        response => {
          resolve(response);
        },
        err => {
          reject(err);
        }
      )
      .catch(error => {
        reject(error);
      });
  });
}
////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
  //debugger
  return axios.get(url, { params: param })  
      .then(response => {  
        // 如果需要对响应数据进行进一步处理，可以在这里做  
        // 但通常只是直接返回响应对象  
        return response; // 或者 return response.data 如果你只需要响应的数据部分  
      })  
      .catch(error => {  
        // 捕获并处理axios请求中的错误  
        // 这里可以抛出一个错误，或者返回一些错误信息  
        throw error; // 或者你可以返回 Promise.reject(error) 来保持一致性，但throw在这里更常见  
      });
}
export default {
  fetchPost,
  fetchGet
};
